/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

export const wordToTitleCase = (word: string) =>
  word && word.length > 0 ? `${word[0].toUpperCase()}${word.substring(1)}` : word;

// renders a short uuid version of any string which contains a uuid, useful for displaying on screen whilst preserving urls etc.
const uuidRegex = /\b([0-9a-f]{8})-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/gi;
export const shortenUuid = (str: string): string => str.replace(uuidRegex, (_match, s) => s);
